<template>
    <div class="skill">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'skill',
    data: function () {
        return {
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.skill {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    text-align: left;
}
</style>
